var _mask, _rect, _path, _circle, _mask2, _rect2, _path2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleDetailEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 151,
    viewBox: "0 0 304 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1918_26073",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 127,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 127,
    rx: 2,
    fill: "white",
    stroke: "#CDDD9A",
    strokeWidth: 10,
    mask: "url(#path-1-inside-1_1918_26073)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2299 78.0851V76.9494C99.2299 74.3287 99.6667 72.0284 100.54 70.0483C101.472 68.01 102.608 66.2046 103.947 64.6322C105.345 63.0015 106.801 61.4874 108.315 60.0897C110.353 58.0513 112.188 56.0713 113.818 54.1494C115.507 52.2276 116.352 49.9563 116.352 47.3356C116.352 45.8215 115.973 44.3946 115.216 43.0552C114.459 41.7157 113.323 40.6383 111.809 39.823C110.353 39.0077 108.548 38.6 106.393 38.6C103.423 38.6 100.861 39.5318 98.7057 41.3954C96.551 43.259 95.2115 45.7341 94.6874 48.8207L87 47.0736C87.5241 43.8705 88.6598 41.0751 90.4069 38.6874C92.2123 36.2414 94.4835 34.3487 97.2207 33.0092C100.016 31.6697 103.103 31 106.48 31C110.266 31 113.527 31.7862 116.264 33.3586C119.06 34.8728 121.215 36.8529 122.729 39.2988C124.243 41.7448 125 44.3946 125 47.2483C125 49.8107 124.476 52.082 123.428 54.0621C122.379 55.9839 121.04 57.7602 119.409 59.3908C117.837 61.0215 116.264 62.6521 114.692 64.2828C112.77 66.1464 111.081 68.0973 109.625 70.1356C108.228 72.1157 107.529 74.4452 107.529 77.1241V78.0851H99.2299Z",
    fill: "#7F9D48"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.38,
    cy: 91.0577,
    r: 5.45977,
    fill: "#7F9D48"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1918_26073",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 43,
    width: 144,
    height: 108,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 43,
    width: 144,
    height: 108,
    rx: 2,
    fill: "white",
    stroke: "#CDDD9A",
    strokeWidth: 10,
    mask: "url(#path-4-inside-2_1918_26073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.23 111.085V109.949C225.23 107.329 225.667 105.028 226.54 103.048C227.472 101.01 228.608 99.2046 229.947 97.6322C231.345 96.0015 232.801 94.4874 234.315 93.0897C236.353 91.0513 238.188 89.0713 239.818 87.1494C241.507 85.2276 242.352 82.9563 242.352 80.3356C242.352 78.8215 241.973 77.3946 241.216 76.0552C240.459 74.7157 239.323 73.6383 237.809 72.823C236.353 72.0077 234.548 71.6 232.393 71.6C229.423 71.6 226.861 72.5318 224.706 74.3954C222.551 76.259 221.211 78.7341 220.687 81.8207L213 80.0736C213.524 76.8705 214.66 74.0751 216.407 71.6874C218.212 69.2414 220.484 67.3487 223.221 66.0092C226.016 64.6697 229.103 64 232.48 64C236.266 64 239.527 64.7862 242.264 66.3586C245.06 67.8728 247.215 69.8529 248.729 72.2988C250.243 74.7448 251 77.3946 251 80.2483C251 82.8107 250.476 85.082 249.428 87.0621C248.379 88.9839 247.04 90.7602 245.409 92.3908C243.837 94.0215 242.264 95.6521 240.692 97.2828C238.77 99.1464 237.081 101.097 235.625 103.136C234.228 105.116 233.529 107.445 233.529 110.124V111.085H225.23Z",
    fill: "#7F9D48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.38,
    cy: 124.058,
    r: 5.45977,
    fill: "#7F9D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleDetailEmptyState);
export default __webpack_public_path__ + "static/media/people-detail-empty-state.4cc2b3ff201f334f44f6270f72fe59f0.svg";
export { ForwardRef as ReactComponent };